// Datos simulados almacenados en localStorage
const STORAGE_KEY = 'wintoncoin-mockdb';

// Crear algunas tareas de demostración
const demoTasks = [
  {
    id: '1',
    title: 'Diseño de logo para startup',
    description: 'Necesito un diseño de logo profesional para mi startup de tecnología. Debe ser moderno, minimalista y representar innovación.',
    category: 'Diseño',
    location: 'Remoto',
    tokens: 100,
    status: 'disponible',
    createdAt: new Date(Date.now() - 86400000 * 2).toISOString(), // 2 días atrás
    images: ['https://via.placeholder.com/800x450?text=Logo+Design'],
    createdBy: {
      _id: '1',
      name: 'Usuario Demo',
      email: 'demo@example.com'
    }
  },
  {
    id: '2',
    title: 'Desarrollo de página web sencilla',
    description: 'Busco desarrollador para crear una landing page responsive con HTML, CSS y JavaScript. Debe incluir formulario de contacto y galería de imágenes.',
    category: 'Programación',
    location: 'Remoto',
    tokens: 150,
    status: 'disponible',
    createdAt: new Date(Date.now() - 86400000).toISOString(), // 1 día atrás
    images: ['https://via.placeholder.com/800x450?text=Web+Development'],
    createdBy: {
      _id: '1',
      name: 'Usuario Demo',
      email: 'demo@example.com'
    }
  },
  {
    id: '3',
    title: 'Traducción de documentos técnicos',
    description: 'Necesito traducir manuales técnicos de español a inglés. Aproximadamente 20 páginas. Se requiere conocimiento en términos de ingeniería.',
    category: 'Traducción',
    location: 'Madrid',
    tokens: 80,
    status: 'disponible',
    createdAt: new Date(Date.now() - 43200000).toISOString(), // 12 horas atrás
    images: ['https://via.placeholder.com/800x450?text=Translation'],
    createdBy: {
      _id: '1',
      name: 'Usuario Demo',
      email: 'demo@example.com'
    }
  }
];

// Inicializar la base de datos simulada si no existe
const initMockDb = () => {
  if (!localStorage.getItem(STORAGE_KEY)) {
    const initialData = {
      users: [
        {
          id: '1',
          name: 'Usuario Demo',
          email: 'demo@example.com',
          password: 'password123',
          tokensBlue: 100,
          tokensRed: 50,
          notifications: true,
          walletAddress: '0x1234567890abcdef1234567890abcdef12345678',
          bio: 'Usuario de demostración',
          createdAt: new Date().toISOString()
        }
      ],
      tasks: [...demoTasks] // Agregar tareas de demostración
    };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(initialData));
  }
};

// Obtener la base de datos simulada
const getMockDb = () => {
  initMockDb();
  return JSON.parse(localStorage.getItem(STORAGE_KEY));
};

// Guardar en la base de datos simulada
const saveMockDb = (data) => {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
};

// Servicios de autenticación simulados
export const mockAuthService = {
  login: async (credentials) => {
    // Simular latencia
    await new Promise(resolve => setTimeout(resolve, 500));
    
    const { email, password } = credentials;
    const db = getMockDb();
    
    const user = db.users.find(u => u.email === email);
    
    if (!user || user.password !== password) {
      throw { 
        response: { 
          data: { message: 'Credenciales inválidas' } 
        } 
      };
    }
    
    const { password: _, ...userWithoutPassword } = user;
    
    return {
      data: {
        token: `mock-token-${user.id}`,
        user: {
          ...userWithoutPassword,
          isAdmin: true
        }
      }
    };
  },
  
  register: async (userData) => {
    // Simular latencia
    await new Promise(resolve => setTimeout(resolve, 800));
    
    const db = getMockDb();
    
    // Verificar si el email ya existe
    if (db.users.some(u => u.email === userData.email)) {
      throw { 
        response: { 
          data: { message: 'El correo electrónico ya está registrado' } 
        } 
      };
    }
    
    // Crear nuevo usuario
    const newUser = {
      id: Date.now().toString(),
      ...userData,
      tokensBlue: 50, // Tokens iniciales
      tokensRed: 20,
      notifications: true,
      createdAt: new Date().toISOString()
    };
    
    // Guardar en "base de datos"
    db.users.push(newUser);
    saveMockDb(db);
    
    const { password, ...userWithoutPassword } = newUser;
    
    return {
      data: {
        token: `mock-token-${newUser.id}`,
        user: {
          ...userWithoutPassword,
          isAdmin: true
        }
      }
    };
  },
  
  getProfile: async () => {
    // Simular latencia
    await new Promise(resolve => setTimeout(resolve, 300));
    
    const token = localStorage.getItem('token');
    
    if (!token || !token.startsWith('mock-token-')) {
      throw { response: { data: { message: 'No autorizado' } } };
    }
    
    const userId = token.replace('mock-token-', '');
    const db = getMockDb();
    
    const user = db.users.find(u => u.id === userId);
    
    if (!user) {
      throw { response: { data: { message: 'Usuario no encontrado' } } };
    }
    
    const { password, ...userWithoutPassword } = user;
    
    return { data: userWithoutPassword };
  },
  
  updateProfile: async (profileData) => {
    // Simular latencia
    await new Promise(resolve => setTimeout(resolve, 500));
    
    const token = localStorage.getItem('token');
    
    if (!token || !token.startsWith('mock-token-')) {
      throw { response: { data: { message: 'No autorizado' } } };
    }
    
    const userId = token.replace('mock-token-', '');
    const db = getMockDb();
    
    const userIndex = db.users.findIndex(u => u.id === userId);
    
    if (userIndex === -1) {
      throw { response: { data: { message: 'Usuario no encontrado' } } };
    }
    
    // Actualizar usuario
    db.users[userIndex] = {
      ...db.users[userIndex],
      ...profileData
    };
    
    saveMockDb(db);
    
    const { password, ...userWithoutPassword } = db.users[userIndex];
    
    return {
      data: {
        message: 'Perfil actualizado correctamente',
        user: userWithoutPassword
      }
    };
  },
  
  forgotPassword: async (email) => {
    // Simular latencia
    await new Promise(resolve => setTimeout(resolve, 800));
    
    // Simular envío de email
    return {
      data: {
        message: 'Se ha enviado un email para recuperación de contraseña'
      }
    };
  },
  
  resetPassword: async (data) => {
    // Simular latencia
    await new Promise(resolve => setTimeout(resolve, 1000));
    
    return {
      data: {
        message: 'Contraseña actualizada correctamente'
      }
    };
  }
};

// Servicios de tareas simulados
export const mockTaskService = {
  // Implementar funciones para tareas simuladas
  getTasks: async (filters = {}) => {
    // Simular latencia
    await new Promise(resolve => setTimeout(resolve, 600));
    
    let { category, sortBy = 'createdAt', sortOrder = 'desc', status = 'disponible', page = 1, limit = 10 } = filters;
    
    const db = getMockDb();
    
    // Si no hay tareas, renovar con las tareas de demo
    if (db.tasks.length === 0) {
      db.tasks = [...demoTasks];
      saveMockDb(db);
    }
    
    // Filtrar tareas
    let filteredTasks = [...db.tasks];
    
    if (status) {
      filteredTasks = filteredTasks.filter(task => task.status === status);
    }
    
    if (category && category !== 'Todas') {
      filteredTasks = filteredTasks.filter(task => task.category === category);
    }
    
    // Ordenar tareas
    filteredTasks.sort((a, b) => {
      if (sortBy === 'price' || sortBy === 'tokens') {
        return sortOrder === 'asc' ? a.tokens - b.tokens : b.tokens - a.tokens;
      } else {
        // Por fecha
        return sortOrder === 'asc' 
          ? new Date(a.createdAt) - new Date(b.createdAt) 
          : new Date(b.createdAt) - new Date(a.createdAt);
      }
    });
    
    // Paginación
    const total = filteredTasks.length;
    const totalPages = Math.ceil(total / limit);
    const startIdx = (page - 1) * limit;
    const endIdx = startIdx + parseInt(limit);
    
    const paginatedTasks = filteredTasks.slice(startIdx, endIdx);
    
    return {
      data: {
        tasks: paginatedTasks,
        pagination: {
          total,
          page: parseInt(page),
          limit: parseInt(limit),
          totalPages,
          hasNextPage: page < totalPages,
          hasPrevPage: page > 1
        }
      }
    };
  },
  
  getTaskById: async (id) => {
    // Simular latencia
    await new Promise(resolve => setTimeout(resolve, 400));
    
    const db = getMockDb();
    
    // Si no hay tareas, renovar con las tareas de demo
    if (db.tasks.length === 0) {
      db.tasks = [...demoTasks];
      saveMockDb(db);
    }
    
    // Buscar la tarea por ID
    // Buscar primero coincidencia exacta
    let task = db.tasks.find(t => t.id === id);
    
    // Si no encuentra coincidencia exacta, buscar por coincidencia parcial
    // Esto es útil cuando se usa ObjectId de MongoDB y queremos encontrar coincidencias
    if (!task) {
      task = db.tasks.find(t => t.id && t.id.includes(id) || id.includes(t.id));
    }
    
    // Si todavía no encuentra la tarea, usar una tarea existente para demostración
    if (!task && db.tasks.length > 0) {
      console.log(`No se encontró tarea con ID ${id}, usando la primera tarea disponible`);
      task = db.tasks[0];
    }
    
    // Si no hay ninguna tarea, crear una demo
    if (!task) {
      console.log('Creando tarea demo porque no hay tareas disponibles');
      task = {
        id: id,
        title: "Tarea de demostración",
        description: "Esta es una tarea de ejemplo creada automáticamente. En una aplicación real, verías aquí los detalles completos de la tarea seleccionada.",
        category: "Programación",
        location: "Remoto",
        tokens: 50,
        status: "disponible",
        createdAt: new Date().toISOString(),
        images: ["https://via.placeholder.com/800x450?text=Tarea+Demo"],
        createdBy: {
          _id: "1",
          name: "Usuario Demo",
          email: "demo@example.com"
        }
      };
      
      // Guardar la tarea demo solo si no hay tareas
      db.tasks.push(task);
      saveMockDb(db);
    }
    
    return { data: task };
  },
  
  createTask: async (taskData) => {
    // Simular latencia
    await new Promise(resolve => setTimeout(resolve, 800));
    
    const token = localStorage.getItem('token');
    
    if (!token || !token.startsWith('mock-token-')) {
      throw { response: { data: { message: 'No autorizado' } } };
    }
    
    const userId = token.replace('mock-token-', '');
    const db = getMockDb();
    
    const user = db.users.find(u => u.id === userId);
    
    if (!user) {
      throw { response: { data: { message: 'Usuario no encontrado' } } };
    }
    
    // Crear nueva tarea
    const newTask = {
      id: Date.now().toString(),
      ...taskData,
      status: 'disponible',
      createdAt: new Date().toISOString(),
      createdBy: {
        _id: userId,
        name: user.name,
        email: user.email
      }
    };
    
    // Guardar en "base de datos"
    db.tasks.push(newTask);
    saveMockDb(db);
    
    return { data: newTask };
  },
  
  acceptTask: async (id) => {
    await new Promise(resolve => setTimeout(resolve, 500));
    
    const token = localStorage.getItem('token');
    if (!token || !token.startsWith('mock-token-')) {
      throw { response: { data: { message: 'No autorizado' } } };
    }
    
    const userId = token.replace('mock-token-', '');
    const db = getMockDb();
    
    const taskIndex = db.tasks.findIndex(t => t.id === id);
    if (taskIndex === -1) {
      throw { response: { data: { message: 'Tarea no encontrada' } } };
    }
    
    // Verificar que no sea el creador
    if (db.tasks[taskIndex].createdBy._id === userId) {
      throw { response: { data: { message: 'No puedes aceptar tu propia tarea' } } };
    }
    
    // Actualizar tarea
    db.tasks[taskIndex].status = 'aceptada';
    db.tasks[taskIndex].acceptedBy = {
      _id: userId,
      name: db.users.find(u => u.id === userId).name,
      email: db.users.find(u => u.id === userId).email
    };
    
    saveMockDb(db);
    
    return { data: { message: 'Tarea aceptada correctamente', task: db.tasks[taskIndex] } };
  },
  
  completeTask: async (id) => {
    await new Promise(resolve => setTimeout(resolve, 500));
    
    const token = localStorage.getItem('token');
    if (!token || !token.startsWith('mock-token-')) {
      throw { response: { data: { message: 'No autorizado' } } };
    }
    
    const userId = token.replace('mock-token-', '');
    const db = getMockDb();
    
    const taskIndex = db.tasks.findIndex(t => t.id === id);
    if (taskIndex === -1) {
      throw { response: { data: { message: 'Tarea no encontrada' } } };
    }
    
    // Verificar que sea el que aceptó la tarea
    if (!db.tasks[taskIndex].acceptedBy || db.tasks[taskIndex].acceptedBy._id !== userId) {
      throw { response: { data: { message: 'Solo el colaborador asignado puede marcar como completada' } } };
    }
    
    // Actualizar tarea
    db.tasks[taskIndex].status = 'culminada';
    
    saveMockDb(db);
    
    return { data: { message: 'Tarea marcada como culminada', task: db.tasks[taskIndex] } };
  },
  
  approveTask: async (id) => {
    await new Promise(resolve => setTimeout(resolve, 500));
    
    const token = localStorage.getItem('token');
    if (!token || !token.startsWith('mock-token-')) {
      throw { response: { data: { message: 'No autorizado' } } };
    }
    
    const userId = token.replace('mock-token-', '');
    const db = getMockDb();
    
    const taskIndex = db.tasks.findIndex(t => t.id === id);
    if (taskIndex === -1) {
      throw { response: { data: { message: 'Tarea no encontrada' } } };
    }
    
    // Verificar que sea el creador
    if (db.tasks[taskIndex].createdBy._id !== userId) {
      throw { response: { data: { message: 'Solo el creador puede aprobar la tarea' } } };
    }
    
    // Actualizar tarea
    db.tasks[taskIndex].status = 'aprobada';
    db.tasks[taskIndex].completedAt = new Date().toISOString();
    db.tasks[taskIndex].transactionHash = '0x' + Math.random().toString(36).substring(2, 15);
    db.tasks[taskIndex].commission = Math.round(db.tasks[taskIndex].tokens * 0.05);
    db.tasks[taskIndex].totalMinted = db.tasks[taskIndex].tokens + db.tasks[taskIndex].commission;
    
    saveMockDb(db);
    
    return { 
      data: { 
        message: 'Tarea aprobada y pagada correctamente', 
        task: db.tasks[taskIndex],
        transaction: {
          tokensTransferred: db.tasks[taskIndex].tokens,
          commission: db.tasks[taskIndex].commission,
          totalMinted: db.tasks[taskIndex].totalMinted,
          transactionHash: db.tasks[taskIndex].transactionHash
        }
      } 
    };
  }
};

// Servicios de mensajería simulados
export const mockMessageService = {
  // Obtener historial de chat
  getChatHistory: async (roomId) => {
    // Simular latencia
    await new Promise(resolve => setTimeout(resolve, 400));
    
    // Extraer IDs de usuario de la roomId (formato: userId1-userId2)
    const [userId1, userId2] = roomId.split('-');
    
    // En una app real, aquí buscaríamos mensajes en la base de datos
    // Por ahora, generamos mensajes de prueba
    const messages = [
      {
        _id: '1',
        message: 'Hola, ¿cómo estás?',
        sender: userId1,
        receiver: userId2,
        sentAt: new Date(Date.now() - 86400000).toISOString() // 1 día atrás
      },
      {
        _id: '2',
        message: 'Muy bien, gracias. ¿En qué puedo ayudarte?',
        sender: userId2,
        receiver: userId1,
        sentAt: new Date(Date.now() - 86300000).toISOString()
      },
      {
        _id: '3',
        message: 'Quería consultarte sobre la tarea que publicaste',
        sender: userId1,
        receiver: userId2,
        sentAt: new Date(Date.now() - 86200000).toISOString()
      },
      {
        _id: '4',
        message: '¿Cuál es el plazo de entrega?',
        sender: userId1,
        receiver: userId2,
        sentAt: new Date(Date.now() - 86100000).toISOString()
      },
      {
        _id: '5',
        message: 'Necesito que esté listo en una semana aproximadamente',
        sender: userId2,
        receiver: userId1,
        sentAt: new Date(Date.now() - 86000000).toISOString()
      },
      {
        _id: '6',
        message: 'Perfecto, puedo hacerlo. ¿Tienes algún requerimiento específico?',
        sender: userId1,
        receiver: userId2,
        sentAt: new Date(Date.now() - 85900000).toISOString()
      },
      {
        _id: '7',
        message: 'Solo necesito que sea responsivo y compatible con los navegadores principales',
        sender: userId2,
        receiver: userId1,
        sentAt: new Date(Date.now() - 85800000).toISOString()
      },
      {
        _id: '8',
        message: 'Sin problema, me pondré a trabajar en ello',
        sender: userId1,
        receiver: userId2,
        sentAt: new Date(Date.now() - 3600000).toISOString() // 1 hora atrás
      }
    ];
    
    return { data: { messages } };
  },
  
  // Enviar mensaje
  sendMessage: async (messageData) => {
    // Simular latencia
    await new Promise(resolve => setTimeout(resolve, 300));
    
    const { sender, receiver, message } = messageData;
    
    if (!sender || !receiver || !message) {
      throw { response: { data: { message: 'Faltan datos requeridos' } } };
    }
    
    // En una app real, aquí guardaríamos el mensaje en la base de datos
    const newMessage = {
      _id: Date.now().toString(),
      sender,
      receiver,
      message,
      sentAt: new Date().toISOString()
    };
    
    // Simular éxito
    return { 
      data: { 
        success: true, 
        message: 'Mensaje enviado correctamente',
        messageData: newMessage
      } 
    };
  }
};

export const mockUploadService = {
  uploadImage: async (file) => {
    // Simular latencia
    await new Promise(resolve => setTimeout(resolve, 1200));
    
    // Simular URL generada para la imagen subida
    const randomId = Math.random().toString(36).substring(2, 15);
    return { 
      data: { 
        imageUrl: `https://via.placeholder.com/500?text=Mock+Image+${randomId}` 
      } 
    };
  }
};

// Inicializar datos
initMockDb();
